export default __webpack_public_path__ + "static/media/mockup-image-01.5f951fb6.jpg";